import type React from 'react';

import { Tooltip } from '@vlabs/uikit';
import cn from 'classnames';

import st from './ColorIcon.module.sass';

interface ColorIconProps {
  children: React.ReactNode;
  colorsConfig?: {
    color: string | null;
    tooltip?: string | null;
  }[];
  size: 'medium' | 'large';
}

export function ColorIcon({
  children,
  colorsConfig = undefined,
  size,
}: ColorIconProps): React.JSX.Element {
  const hasColors = colorsConfig && colorsConfig.length > 0;

  const mainColor = hasColors && colorsConfig[0]?.color;
  const additionalColors = hasColors && colorsConfig.slice(1).map((color) => color.color);

  const colorsTooltipContent = hasColors && colorsConfig.map((color) => color.tooltip).join(', ');

  return (
    <div className={cn(st.Wrapper, st[`Wrapper_${size}`])}>
      <Tooltip
        className={cn(
          st.ColorIcon,
          { [st[`ColorIcon_${mainColor}`] as string]: mainColor },
        )}
        tooltipContent={colorsTooltipContent ?? null}
        tooltipProps={{ place: 'top' }}
      >
        {children}
      </Tooltip>

      {!!additionalColors && additionalColors.length > 0 && (
        <div className={st.AdditionalColors}>
          {additionalColors.map((color) => (
            <div
              className={cn(
                st.AdditionalColors_item,
                { [st[`ColorIcon_${color}`] as string]: color },
              )}
              key={color}
            />
          ))}
        </div>
      )}
    </div>
  );
}
